import { DatePicker, Flex, Space, Table } from 'antd'
import React, { useState } from 'react'
import { useQuery } from '@apollo/client'
import { translate } from '../../../core'
import { dateDisplay, dateFormatAndTimeSlashed, dateFormatSlashed } from '../../../core/until'
import { ItemBulkUpdateHistory, ItemBulkUpdateHistoryRequest } from '../type/item-bulk-update-history'
import { ItemBulkHistoryQuery } from '../graphql/item-bulk-history.graphql'
import { ItemBulkUpdateHistoryItemList } from './ItemBulkUpdateHistoryItemList'
import { FilterOutlined } from '@ant-design/icons'
import { ItemFormSelector } from './ItemFormSelector'
import { Dayjs } from 'dayjs'
import { InputCard } from './InputCard'

export const ItemBulkUpdateHistoryList = () => {
  const [currentPage, setCurrentPage] = useState<number>(0)
  const [pageSize, setPageSize] = useState<number>(10)
  const [searchRequest, setSearchRequest] = useState<ItemBulkUpdateHistoryRequest>()
  const {data, loading} = useQuery(ItemBulkHistoryQuery, {
    variables: {
      request: {
        take: pageSize,
        skip: currentPage * pageSize,
        ...(searchRequest ?? {}),
      }
    }
  })

  return (
    <InputCard contained>
      <Flex className='p-2 mb-3'>
        <Flex className='w-100' justify='start' align='start'>
          <Space>
            <FilterOutlined/>
            <ItemFormSelector
              style={{width: 200}}
              onChange={id => setSearchRequest(pre => ({
                ...pre,
                itemId: id
              }))}
              defaultRequest={{
                showNoEffects: true,
              }}
            />

            <DatePicker.RangePicker
              onChange={date => {
                const [min, max] = (date ?? []) as Dayjs[]
                setSearchRequest(pre => ({
                  ...pre,
                  dateRange: {
                    min: min ? min.format(dateFormatSlashed) : null,
                    max: max ? max.format(dateFormatSlashed) : null,
                  }
                } as any))
              }}
            />
          </Space>
        </Flex>
      </Flex>

      <Table<ItemBulkUpdateHistory>
        loading={loading}
        columns={[
          {
            dataIndex: 'id',
            title: translate('#'),
            width: 50,
          },
          {
            dataIndex: 'createdAt',
            title: translate('created_at'),
            width: 200,
            render: value => dateDisplay(value, dateFormatAndTimeSlashed),
          },
        ]}
        dataSource={data?.itemBulkUpdateHistoryFind.data.map(it => ({key: it.id.toString(), ...it})) ?? []}
        pagination={{
          total: data?.itemBulkUpdateHistoryFind.count,
          position: ['bottomCenter'],
          pageSize: pageSize,
          showSizeChanger: true,
        }}
        onChange={e => {
          if (e.current)
            setCurrentPage(e.current - 1)

          if (e.pageSize)
            setPageSize(e.pageSize)
        }}
        expandable={{
          expandedRowRender: record =>
            <ItemBulkUpdateHistoryItemList
              historyId={record.id}
              itemId={searchRequest?.itemId}
            />
        }}
      />
    </InputCard>
  )
}